<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-md-12">
        <div class="row" v-if="errors.length > 0">
          <div class="col-md-12">
            <div class="alert alert-danger mt-2">
              <ul style="margin-bottom: 0px">
                <li v-for="error in errors" :key="error">
                  {{ error[0] }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <form @submit.prevent="onSubmit" enctype="multipart/form-data" class="col-md-12">
            <div class="row mt-2">
              <div class="col-md-6">
                <label>{{ $t("pages.roles.name") }} </label>
                <input v-model.trim="forms.name" class="form-control mb-4" required />
              </div>
              <div class="col-md-6">
                <label> {{ $t("pages.roles.description") }} </label>
                <input v-model.trim="forms.slug" class="form-control mb-4" required />
              </div>
            </div>
            <h4>{{ $t("pages.roles.permissions") }}</h4>
            <hr />
            <div class="row mt-2" v-if="gettingPermissions">
              <b-skeleton-table :rows="6" :columns="4"></b-skeleton-table>
            </div>
            <div class="row" v-else>
              <div class="col-md-12">
                <table class="table table-bordered table-hover">
                  <thead>
                    <!-- <th></th> -->
                    <th>Créer</th>
                    <th>Lister</th>
                    <th>Détails</th>
                    <th>Modifier</th>
                    <th>Supprimer</th>
                  </thead>
                  <tbody>
                    <tr class="col-md-12" v-for="(key, index) in Object.keys(permissions_group)" :key="index">
                      <!-- <td class="mt-4">{{ $t("pages.roles.groups." + key) }}</td> -->
                      <td class="text-left" v-for="(p, index) in permissions_group[key]" :key="index">
                        <div class="form-check mt-2">
                          <input class="form-check-input" v-model="permission.permission_id" type="checkbox"
                            :value="p.id" :id="p.name" />
                          <label class="form-check-label" :for="p.name">
                            {{ $t("pages.roles.rights." + p.slug) }}
                          </label>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div
                class="col-md-12"
                v-for="(key, index) in Object.keys(permissions_group)"
                :key="index"
              >
                <h4 class="mt-4">{{ $t("pages.roles.groups." + key) }}</h4>
                <div class="row">
                  <div
                    class="col-md-3 text-left"
                    v-for="(p, index) in permissions_group[key]"
                    :key="index"
                  >
                    <div class="form-check mt-2">
                      <input
                        class="form-check-input"
                        v-model="permission.permission_id"
                        type="checkbox"
                        :value="p.id"
                        :id="p.name"
                      />
                      <label
                        class="form-check-label"
                        :for="p.name"
                      >
                        {{ $t("pages.roles.rights." + p.slug) }}
                      </label>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
            <hr />
            <div class="row mt-4 mb-3">
              <div class="col-md-12">
                <button v-if="this.isLoading === false" type="submit" class="btn btn-primary mr-2">
                  {{ $t("pages.users.save") }}
                </button>
                <button class="btn btn-primary mr-2" type="button" v-else disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {{ $t("pages.users.saving") }}
                </button>
                <router-link :to="{ name: 'Roles' }" class="btn btn-light">{{ $t("pages.users.cancel") }}</router-link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>


<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions, mapState } from "vuex";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "CreateRole",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      roles: [],
      permissions: [],
      permission: {
        permission_id: [],
      },
      permissions_group: {},
      title: "pages.roles.role",
      items: [
        {
          text: "pages.roles.Paramètres",
        },
        {
          text: "pages.roles.role",
          active: true,
        },
      ],

      forms: {
        name: "",
        slug: "",
        permission: {
          permission_id: [],
        },
      },

      isLoading: false,
      gettingPermissions: false,
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.user.errors,
    }),
  },
  methods: {
    ...mapActions(["createRole", "groupPermissions"]),
    onSubmit() {
      if (this.$can("create", "roles")) {
        this.isLoading = true;
        if (this.permission.permission_id.length > 0) {
          let role = {
            name: this.forms.name,
            slug: this.forms.slug,
            permissions_group: this.permission,
          };
          this.createRole(role)
            .then((response) => {
              if (response.status == 200) {
                this.$toasted.success(this.$t('pages.users.actions.roles.created'));

                this.isLoading = false;
                this.$router.push({ name: "Roles" });
              }
            })
            .catch((err) => {
              this.isLoading = false;
              this.$toasted.error(this.$t('pages.unauthorized.error_0'));
              console.log(err);
            });
        } else {
          this.$toasted.error(this.$t('pages.users.actions.roles.checked'));
        }
        this.isLoading = false;
      } else {
        this.$toasted.error(this.$t('pages.unauthorized.forbidden_1'));
      }
    },

    cancel() {
      this.forms = {
        name: "",
      };
    },
  },
  mounted() {
    this.$store.commit("CLEAR_ERROR_STATE");
  },
  created() {
    this.gettingPermissions = true;
    this.groupPermissions()
      .then((response) => {
        if (response.status == 200) {
          this.permissions_group = response.data;
          this.gettingPermissions = false;
        } else {
          this.gettingPermissions = false;
        }
      })
      .catch((err) => {
        this.gettingPermissions = false;
        console.log(err);
      });
  },
};
</script>

<style scoped>
.form-check-label,
.form-check-input {
  cursor: pointer;
}
</style>




